import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';


export const deleteAttributeValueFunc = createAsyncThunk("delete attribute value function", async (id, thunkAPI) => {
  try {
    const response = await api.delete(`/dashboard/attributes/values/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

const deleteAttributeValueSlicer = createSlice({
  name: "delete attribute value slicer",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(deleteAttributeValueFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    })
      .addCase(deleteAttributeValueFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";

      })
      .addCase(deleteAttributeValueFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  }
});

export default deleteAttributeValueSlicer.reducer;
